import Axios from 'axios';

const initialiseInterceptor = () => {
    if (typeof window !== 'undefined') {
        Axios.interceptors.request.use(
            (config) => {
                const token = localStorage.getItem('access_token');
                if (token) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
                return config;
            },
            (error) => Promise.reject(error),
        );

        Axios.interceptors.response.use(
            (response) => response,
            (error) => {
                const status = error?.response?.status;

                if (status === 401 || status === 403) {
                    localStorage.removeItem('access_token');

                    if (window.parent !== window) {
                        window.parent.postMessage({ type: 'FORCE_LOGOUT' }, '*');
                    } else {
                    }

                    return Promise.reject(error);
                }

                return Promise.reject(error);
            },
        );
    }
};

export default initialiseInterceptor;
